import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';

@Component({
  selector: 'edex-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit {

  public userId: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public location: Location
  ) { }

  ngOnInit() {
    this.userId = this.route.snapshot.paramMap.get('id');
  }

}
